import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Produto, CartItem } from '../tamas-models';
import {AlertaPremiumDialog} from '../alerta-premium';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-shop-pedido',
  templateUrl: './shop-pedido.component.html',
  styleUrls: ['./shop-pedido.component.css']
})
export class ShopPedidoComponent implements OnInit {

  hideCL: boolean = false;
  categoriaAtual: any = '';
  idProduto: any = 0;
  mUF: any = '';
  mCidade: any = '';
  urlFoto: any = '';
  numPedidoAtual: any = 0
  arrPedProdutos: any[] = [];
  resumoPedido: any = '';
  resumoEntrega: any = '';
  resumoRetirada: any = '';
  urlECfoto: any = '';
  tipoPedido: any = '';

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService,  public dialog: MatDialog) { }


  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    this.numPedidoAtual = this.route.snapshot.paramMap.get('id');
    this.carregarInfoPedido();
  }

  ngOnDestroy() {
    this.tmaService.eventoFS(false);
  }

  carregarInfoPedido() :void{
    this.hideCL = false;
    var dadosBc = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpedido=' + this.numPedidoAtual;
    this.tmaService.infoPedido(dadosBc)
    .subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.urlECfoto =  this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
        this.arrPedProdutos = qRes['arrProdutos'];
        this.resumoPedido = qRes['resumoPedido'];
        this.resumoEntrega = qRes['resumoEntrega'];
        if(this.resumoPedido.DataPedido != null){
          this.resumoPedido.DataPedido = moment(this.resumoPedido.DataPedido).format('DD/MM/YYYY');
        }
        
        if(this.resumoPedido.TipoEntrega == 'retirada'){
          this.tipoPedido = 'retirada';
          this.resumoRetirada = qRes['infoRetirada'];

        }
        else{
          this.tipoPedido = 'entrega';
        }
        //this.arrMeusPedidos = qRes['arrPedidos'];
      }
    })
  }
  voltar() :void{
    //this._location.back();
    this.router.navigate(['/shopping/pedidos']);
  }

  goPedido(idpedido: any){
    this.router.navigate(['shopping/pedido/' + idpedido]);
  }


  goAvaliar(){
    this.tmaService.paginaAnterior = 'shopping/pedido/' + this.numPedidoAtual;
    this.router.navigate(['/shopping/avaliar/' + this.numPedidoAtual]);

  }
}
